<script>
    import LookbookImage from "@xd/components/LookbookImage";
    import LookbookDot from "@xd/components/LookbookDot";
    import { lookbookMixin } from "@xd/mixins/lookbook";

    export default {
        name: "LookbookTemplateThree",
        components: {
            LookbookDot,
            LookbookImage,
        },
        props: {
            name: String,
            offerId: String,
            dot: Object,
            product: Object,
            visibleElements: Array,
        },
        mixins: [lookbookMixin],
    };
</script>

<template>
    <div class="lookbook-template">
        <div class="lookbook-template__inner">
            <div class="lookbook-template__image image-0 image-square">
                <lookbook-image
                    :name="name"
                    index="1"
                    data-name="image-0"
                    :is-animated="mixinCheckElement('image-0')"
                ></lookbook-image>
            </div>

            <div class="lookbook-template__image image-1 image-rect">
                <lookbook-image
                    :name="name"
                    index="2"
                    data-name="image-1"
                    :is-animated="mixinCheckElement('image-1')"
                ></lookbook-image>
            </div>

            <div class="lookbook-template__image image-2 image-full-width">
                <lookbook-dot
                    :style="mixinDotStyle"
                    data-name="dot"
                    :tooltip-position="dot.tooltip"
                    :product="product"
                    :offer-id="offerId"
                    :is-animated="mixinCheckElement('dot')"
                ></lookbook-dot>
                <lookbook-image
                    :name="name"
                    index="3"
                    data-name="image-2"
                    direction="left"
                    :is-animated="mixinCheckElement('image-2')"
                ></lookbook-image>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .lookbook-template__image {
        &.image-0,
        &.image-1 {
            margin: 0 0 16px;
        }
        &.image-2 {
            margin: 0 -16px;
        }
        @include bp($bp-desktop-sm) {
            &.image-0 {
                margin-right: 40px;
                margin-bottom: 40px;
                margin-left: 0;
            }
            &.image-1 {
                margin-right: 0;
                margin-bottom: 40px;
            }
            &.image-2 {
                margin: 0;
            }
        }
    }
</style>
